import { useRef, useState } from 'react';

type AudioPlayerProps = {
  text?: string;
  audioUrl?: string;
  language?: string;
  label?: string;
  onStarted?: () => void;
  allowGeneratedVoice?: boolean;
};

/**
 * Reviewed-media gate: learner-facing audio is rendered only when a real
 * studio/reviewed audio asset is attached to the block. Device TTS is never
 * used as lesson media.
 */
export default function AudioPlayer({ audioUrl, label = 'Listen', onStarted }: AudioPlayerProps) {
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  if (!audioUrl) return null;

  const play = () => {
    const audio = audioRef.current;
    if (!audio) return;
    void audio.play().then(() => { setPlaying(true); onStarted?.(); }).catch(() => setPlaying(false));
  };
  const stop = () => {
    audioRef.current?.pause();
    if (audioRef.current) audioRef.current.currentTime = 0;
    setPlaying(false);
  };

  return <div className="talkup-audio-player studio-audio-player">
    <audio ref={audioRef} src={audioUrl} preload="metadata" onEnded={() => setPlaying(false)} />
    <button type="button" className="audio-main-button" onClick={playing ? stop : play}>{playing ? '■ Stop' : '▶ ' + label}</button>
    <span className="audio-quality" aria-live="polite">Studio audio</span>
  </div>;
}
